import type { MedplumClient } from '@medplum/core';
import type { Attachment, Reference } from '@medplum/fhirtypes';
import { UserFacingError } from './userFacingError';

/** Medplum validates decoded base64Binary at 1 MiB; stay under that after base64 expansion. */
const MAX_INLINE_ATTACHMENT_BYTES = 700 * 1024;

export function attachmentDataUrl(attachment: Attachment): string {
  if (!attachment.data || !attachment.contentType) throw new Error('Attachment has no inline data.');
  return `data:${attachment.contentType};base64,${attachment.data}`;
}

/** Keep bytes on the authorized parent resource; direct Binary access cannot be safely scoped by Medplum. */
export async function createSecuredAttachment(
  _medplum: MedplumClient,
  file: File | Blob,
  _securityContext: Reference,
  filename?: string,
  contentType?: string,
): Promise<Attachment> {
  if (file.size > MAX_INLINE_ATTACHMENT_BYTES) {
    throw new UserFacingError('Attachment must be 700 KB or smaller.');
  }
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return {
    data: btoa(binary),
    title: filename,
    contentType: contentType || file.type || 'application/octet-stream',
    size: file.size,
  };
}
